export const isNumberValid = (value: string): boolean => {
  const regex = /^[0-9\b]+$/;
  return regex.test(value);
};

export const randomInt = (min: number, max: number): number =>
  Math.floor(Math.random() * (max - min + 1) + min);

export const isEven = (number: number): boolean => number % 2 === 0;
